module.exports = __webpack_public_path__ + "static/media/005.477b8aa4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/totoro/005.gif
// module id = 838
// module chunks = 0